/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'advertiser-status-label',
  template: `
    <span class="label {{labelClass}}">{{ translation }}</span>
  `
})
export class AdvertiserStatusLabelComponent implements OnInit, OnChanges {
  labelClass: any;
  translation: string;
  @Input() bidInLastDay: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.updateLabel();
  }

  ngOnChanges(): void {
    this.updateLabel();
  }

  private updateLabel(): void {
    this.labelClass = this.bidInLastDay ? 'label-success' : 'label-warning';
    this.translation = this.bidInLastDay ? 'Delivering' : 'No Recent Bids';
  }
}
